import Comp from "./Header";

export default Comp;
